module.exports = __webpack_public_path__ + "static/media/a5-l.34895c62.png";